// Posições de decúbito (ordem de rotação) e ilustrações
export const POSICOES_DECUBITO = [
  "Decúbito Dorsal",
  "Decúbito Lateral Esquerdo",
  "Decúbito Lateral Direito",
];

export const IMG_DECUBITO = {
  "Decúbito Dorsal": "https://static.prod-images.emergentagent.com/jobs/ac231617-6b16-4326-96b2-1f7751d95bf3/images/05587798edccfbc150fa856636f5fca50cc93c50107c8bc769a4186bc15d6938.jpeg",
  "Decúbito Lateral Esquerdo": "https://static.prod-images.emergentagent.com/jobs/ac231617-6b16-4326-96b2-1f7751d95bf3/images/be041f9c3d212df475ea13d16bac1f25d990c8d4aeb0d0397150ac4cb2073350.jpeg",
  "Decúbito Lateral Direito": "https://static.prod-images.emergentagent.com/jobs/ac231617-6b16-4326-96b2-1f7751d95bf3/images/e524325909e0d75f805100c8f6e9016b39461093d04acf09074907f46916703d.jpeg",
};

export function proximaPosicaoDecubito(ultimaPosicao) {
  const idx = POSICOES_DECUBITO.indexOf(ultimaPosicao);
  if (idx === -1) return POSICOES_DECUBITO[0];
  return POSICOES_DECUBITO[(idx + 1) % POSICOES_DECUBITO.length];
}
